import "./Home.css";

// import banner from '../../images/banner.png';

function Home() {
  return (
    <div id="home">
      <h1>
        Hola, <br />
        soy Alfred
      </h1>
      <h2 className="h4">¿En qué puedo ayudarte?</h2>
      <h2 className="h3">Visítanos en nuestro stand de ProXymo</h2>
    </div>
  );
}

export default Home;
